var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPatronize = function SvgPatronize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "nonzero",
    d: "M14.124 0c3.085 0 5.593 2.458 5.593 5.5v4.999l8.175.001a4.1 4.1 0 0 1 2.943 1.196l.162.171a3.96 3.96 0 0 1 .956 3.238l-2.112 13.498c-.306 1.974-2.04 3.42-4.05 3.397H8L7.983 32H4.27C2.137 32.04.3 30.364.01 28.08L0 27.94V17.23l.009-.14C.303 14.783 2.156 12.962 4.255 13h3.327L13.213.587A1 1 0 0 1 14.124 0m.62 2.052L9 14.715V30h16.801c.98.01 1.818-.644 2.034-1.551l.03-.154 2.112-13.498a1.96 1.96 0 0 0-.476-1.602 2.1 2.1 0 0 0-1.598-.695h-9.186a1 1 0 0 1-1-1v-6c0-1.671-1.205-3.075-2.82-3.42zM7 15H4.711c-1.27-.021-2.433.96-2.692 2.206L2 17.31v10.546l.02.107c.24 1.132 1.274 1.979 2.527 2.034l.181.002H7z"
  }))));
};
export default SvgPatronize;